export default {
  survey: {}
}
